import gql from 'graphql-tag';

export default gql`
mutation setPreviewSlug($object: SetPreviewSlugInput!) {
  setPreviewSlug(object: $object) {
    preview_slug
    code
    message
  }
}
`;
